import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {Document} from "../../../../shared/interface/document";
import {MatPaginator} from "@angular/material/paginator";
import {ReceivablesImportRow} from "../../../../shared/interface/receivables-import-row";
import {MatTableDataSource} from "@angular/material/table";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {DocumentService} from "../../../../shared/services/document.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../../shared/services/auth.service";
import {takeUntil} from "rxjs/operators";

@Component({
  selector: 'app-receivables-imports-row-list',
  templateUrl: './receivables-imports-row-list.component.html',
  styleUrls: ['./receivables-imports-row-list.component.scss']
})
export class ReceivablesImportsRowListComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() receivablesImportRows: Observable<ReceivablesImportRow[]>;
  @Output() changed: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild(MatPaginator) paginator: MatPaginator;

  receivablesImportRowDataSource: MatTableDataSource<ReceivablesImportRow> = new MatTableDataSource<ReceivablesImportRow>([]);
  displayedColumns: string[] = [
    'policyNumber', 'amount',  'delatationAt', 'insuranceCompany',  'ofwca', 'company', 'status'
  ];
  userPermissions: ReplaySubject<UserPermissions>;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private documentService: DocumentService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.receivablesImportRows
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((documents: Document[]) => this.receivablesImportRowDataSource.data = documents);
  }

  ngAfterViewInit(): void {
    this.receivablesImportRowDataSource.paginator = this.paginator;
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

}
